import { createActions } from 'redux-actions';

export const { showSidebar, hideSidebar } = createActions({
  SHOW_SIDEBAR: () => ({}),
  HIDE_SIDEBAR: () => ({})
});



// WEBPACK FOOTER //
// ./src/store/sidebar/actions.js